<div class="position-relative">
    <h1 class="panel-title position-relative">
        {{data?.msg}}<button type="button" class="close" aria-label="Close" mat-dialog-close>
            <span aria-hidden="true">&times;</span>
        </button>
    </h1>
    <div>
        <app-common-table [tableData]="tableMasterData" [columnHeader]="columnHeader" class="app-common-table"
            pageType="device-attribute" [actionPermission]="{pagination:false,edit:true}"
            (tableAction)="tableAction($event)">
        </app-common-table>
    </div>
</div>